import { configureStore } from "@reduxjs/toolkit";
import activeCourseNameReducer from './activeCourseName/activeCourseNameSlice';
import addOnPopupTogglesReducer from './addOnPopupToggles/addOnPopupTogglesSlice';
import { coursesApi } from '../api/courses';
import { messagesApi } from "../api/messages";

const store = configureStore({ 
    reducer: {
        activeCourseName: activeCourseNameReducer,
        addOnPopupToggles: addOnPopupTogglesReducer,
        [coursesApi.reducerPath]: coursesApi.reducer,
        [messagesApi.reducerPath]: messagesApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([coursesApi.middleware, messagesApi.middleware])
});

export default store;